export const TID = {
  nav: {
    root: "nav-root",
    logo: "nav-logo",
    linkAbout: "nav-link-about",
    linkPhilosophy: "nav-link-philosophy",
    linkPrograms: "nav-link-programs",
    linkTestimonials: "nav-link-testimonials",
    linkContact: "nav-link-contact",
    ctaBook: "nav-cta-book",
  },
  hero: {
    root: "hero-root",
    ctaPrimary: "hero-cta-primary",
    ctaSecondary: "hero-cta-secondary",
  },
  bio: "coach-bio-section",
  manifesto: "manifesto-section",
  programs: "programs-section",
  testimonials: "testimonials-section",
  marquee: "editorial-marquee",
  contact: {
    root: "contact-section",
    parentName: "input-parent-name",
    email: "input-email",
    phone: "input-phone",
    childName: "input-child-name",
    childAge: "input-child-age",
    program: "select-program",
    experience: "select-experience",
    message: "input-message",
    submit: "submit-inquiry",
  },
  admin: {
    root: "admin-root",
    table: "admin-table",
  },
};
